import React, { FC } from 'react'
import './Consultation.scss'

interface NumberedListContentProps {
  className?: string
}

export const NumberedListContent: FC<NumberedListContentProps> = (props) => {
  return (
    <>
      {props.className === 'consultation-step' ? (
        <div className='grid-flex grid-justify-center'>
          <div className='grid-item consultation-sub-headline'>
            <div className={'grid-item'}>Stell uns Fragen zu Themen wie:</div>
            <div className={'grid-item'}>1. Wert deiner Immobilie.</div>
            <div className={'grid-item '}>2. Immobilienmarkt in deiner Region.</div>
            <div className={'grid-item '}>3. Deiner optimalen Vermarktungsstrategie.</div>
          </div>
        </div>
      ) : (
        <div className='grid-flex grid-justify-center'>
          <div className='grid-item buyer-leads-value-proposition-sub-headline'>
            <div className={'grid-item'}> 1. Du machst einige Angaben zu deinem Budget.</div>
            <div className={'grid-item '}>2. Wir berechnen die Finanzierbarkeit.</div>
            <div className={'grid-item '}>3. Unsere Partner senden dir passende Immobilien zu.</div>
          </div>
        </div>
      )}
    </>
  )
}
export default NumberedListContent
